import ajax from '../util/ajax';

/**
 * 全国学会建设情况
 */
export function xhjianshe() {
    return ajax({
        url: '/scimallH5/Dxsv2xhqj/xhjianshe'
    });
}

/**
 * 全国学会理事成员情况
 */
export function xhlishi() {
    return ajax({
        url: '/scimallH5/Dxsv2xhqj/xhlishi'
    });
}

/**
 *  全国学会会员情况
 */
export function vipNum() {
    return ajax({
        url: '/scimallH5/Dxssociety/vipNum'
    });
}

/**
 * 全国学会办事机构党组织类型
 */
export function organizationType() {
    return ajax({
        url: '/scimallH5/Dxsv2xhqj/organizationType'
    });
}

/**
 * 全国学会举办学术会议次数
 */
export function meetingCount() {
    return ajax({
        url: '/scimallH5/Dxsv2xhqj/meetingCount'
    });
}

/**
 * 全国学会咨询工作情况
 */
export function consulting(type=1) {   //  接口有问题   只返回一个数据
    return ajax({
        url: '/scimallH5/Dxssociety/consulting',
        params: {
            type: type
        }
    });
}

/**
 * 科普宣讲活动
 */
export function kpxj() {
    return ajax({
        url: '/scimallH5/Dxsv2xhqj/kpxj'
    });
}


/**
 * 全国学会综合业务能力评估
 */
export function assess() {
    return ajax({
        url: '/scimallH5/Dxssociety/assess'
    });
}


/**
 * 世界主要科技社团成立数量
 */
export function createCount() {
    return ajax({
        url: '/scimallH5/Dxskjst/createCount'
    });
}

/**
 * 理事会成员数
 */
export function usersum() {
    return ajax({
        url: '/scimallH5/Dxsv2xhqj/usersum'
    });
}

/** 全国学会建设情况 **/

/**
 *  全国学会建设情况 - 二级页
 */
export function xhjianshedetail() {
    return ajax({
        url: '/scimallH5/Dxsv2xhqj/xhjianshedetail'
    });
}


/** 全国学会理事会成员情况 **/

/**
 *  理事会成员数
 */
// export function usersum() {
//     return ajax({
//         url: '/scimallH5/Dxsv2xhqj/usersum'
//     });
// }


/**
 *  理事会成员分组情况
 */
export function usergroup() {
    return ajax({
        url: '/scimallH5/Dxsv2xhqj/usergroup'
    });
}


/** 全国学会会员情况 **/

/**
 *  会员申请量环比增速
 */
export function getApplicationVolume() {
    return ajax({
        url: '/scimallH5/Dxsv2membership/getApplicationVolume'
    });
}


/**
 *  本年度会员申请数量
 */
export function getApplicationCount() {
    return ajax({
        url: '/scimallH5/Dxsv2membership/getApplicationCount'
    });
}


/**
 *  会员地域分布
 */
export function memberRegion() {
    return ajax({
        url: '/scimallH5/Dxssociety/memberRegion'
    });
}


/**
 *  各类会员的年龄分布
 */
export function memberAge() {
    return ajax({
        url: '/scimallH5/Dxssociety/memberAge'
    });
}


/**
 *  各类会员的学历分布
 */
export function memberEdu() {
    return ajax({
        url: '/scimallH5/Dxssociety/memberEdu'
    });
}


/**
 *  各类会员的性别分布
 */

export function memberSex() {
    return ajax({
        url: '/scimallH5/Dxssociety/memberSex'
    });
}



/**
 *  组织力-发达国家与发展中国家分项指标均分
 */
export function getOrganizationalPower() {
    return ajax({
        url: '/scimallH5/Dxsv2kjst/getOrganizationalPower'
    });
}


/**
 *  影响力-分项指标均分
 */
export function getEffect() {
    return ajax({
        url: '/scimallH5/Dxsv2kjst/getEffect'
    });
}


/** 世界主要科技社团数量 - 二级 **/

/**
 *  科技社团各成立时间段占比 各国科技社团占比 各学科科技社团占比
 */

export function getServiceGroup() {
    return ajax({
        url: '/scimallH5/Dxsv2kjst/getServiceGroup'
    });
}


/**
 *  世界主要科技社团分布
 */
export function world() {
    return ajax({
        url: '/scimallH5/Dxskjst/world'
    });
}


/**

 *  组织力-发达国家与发展中国家分项指标均分
 */
// export function getOrganizationalPower() {
//     return ajax({
//         url: '/Dxsv2kjst/getOrganizationalPower'
//     });
// }


/**
 * 凝聚力-学科指标均分 凝聚力-各阶段社团分项指标均分
 */
export function getCohesiveForce() {
    return ajax({
        url: '/scimallH5/Dxsv2kjst/getCohesiveForce'
    });
}

/*
 * =====================================================
 *                       服务能力
 * =====================================================
 */

/**
 * 学会排名
 * @method getRanking
 * @public
 */
export function getRanking(type = 0, sort = 0) {
    return ajax({
        url: '/scimallH5/Dxssociety/Ranking',
        params: {
            type: type,
            sort: sort
        }
    });
}

/**
 * 学会分布
 * @method getDistribute
 * @public
 */
export function getDistribute() {
    return ajax({
        url: '/scimallH5/Dxssociety/distribute'
    });
}

/**
 * 学会综合能力
 * @method getSynthesize
 * @public
 */
export function getSynthesize() {
    return ajax({
        url: '/scimallH5/Dxssociety/synthesize'
    });
}

/**
 * 学会党的建设
 * @method getDang
 * @public
 */
export function getDang() {
    return ajax({
        url: '/scimallH5/Dxssociety/dang'
    });
}

/**
 * 规模和总能力分析
 * @method getGmnl
 * @public
 */
export function getGmnl() {
    return ajax({
        url: '/scimallH5/Dxssociety/gmnl'
    });
}

/**
 * 学科发展对比
 * @method getDiscipline
 * @public
 */
export function getDiscipline() {
    return ajax({
        url: '/scimallH5/Dxssociety/discipline'
    });
}
/**
 * 学科发展对比
 * @method getBusiness
 * @public
 */
export function getBusiness() {
    return ajax({
        url: '/scimallH5/Dxssociety/business'
    });
}


/*
 * =====================================================
 *                       学会全景 6图 三级页面
 * =====================================================
 */
/**
 * 会员申请量环比增长
 * @method getCrowdDetailById
 * @param { Number } id 学会id
 * @public
 */
export function getCrowdDetailById(id=49) {
    return ajax({
        url: '/scimallH5/Dxssociety/crowdDetailById',
        params: {
            id: id
        }
    });
}
